<br>
<div class="col-md-10">
  <p-table #dt [columns]="cols" [value]="countries" [paginator]="false" [autoLayout]="true">
    <ng-template pTemplate="caption">
      <div style="text-align: left;" class="rubrik">Hantera Country<span><button class="btn border pull-right" style="margin-left:20px;" (click)="resetFilter()" title="Rensa filter">Rensa filter</button><button class="btn border pull-right" style="margin-left:20px;"
            (click)="exportToCSV()">Excel</button><button class="btn border pull-right" (click)="addCountry();">Lägg till</button></span></div>
      <br>
      <span class="pull-left">Antal poster: {{countries?.length}}</span>
      <div style="text-align: right">
        <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
        <input type="text" #globalfilter pInputText size="50" placeholder="Globalt filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
          {{col.header}}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
        <th>Action</th>
      </tr>
      <tr>
        <th *ngFor="let col of columns" [ngSwitch]="col.field">
          <input *ngSwitchCase="'isoCode'" pInputText type="text" [value]="dt.filters['isoCode'] ? dt.filters['isoCode'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'name'" pInputText type="text" [value]="dt.filters['name'] ? dt.filters['name'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'order'" pInputText type="text" [value]="dt.filters['order'] ? dt.filters['order'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
        </th>
        <th style="text-align: center;"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-i="rowIndex" let-columns="columns">
      <tr [pSelectableRow]="rowData">
        <td *ngFor="let col of columns">
          {{rowData[col.field]}}
        </td>
        <td><span style="display: inline-block;"><i class="fa fa-trash" style="font-size:12px;" (click)="remove(rowData)" title="Radera aktuellt land"></i><i class="fa fa-edit" style="font-size:12px;margin-left:10px;" (click)="edit(rowData)" title="Ändra aktuellt land"></i></span></td>
      </tr>
    </ng-template>
  </p-table>
</div>
<p-dialog header="Editera land" [(visible)]="display" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
  <app-admin-country-edit [formdata]="formdata" (doSave)="saveCountry($event)" (doCancel)="cancelEdit()"></app-admin-country-edit>
</p-dialog>

<p-dialog header="Lägg till land" [(visible)]="displayaddcountry" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
  <app-admin-country-add [formdata]="formdata" (doSave)="saveAddCountry($event)" (doCancel)="cancelAdd()"></app-admin-country-add>
</p-dialog>